
// @ts-nocheck


export const localeCodes =  [
  "en-GB",
  "fi",
  "sv",
  "de",
  "pl"
]

export const localeLoaders = {
  "en-GB": [
    {
      key: "locale_en_45GB_46json_b45b705b",
      load: () => import("#nuxt-i18n/b45b705b" /* webpackChunkName: "locale_en_45GB_46json_b45b705b" */),
      cache: true
    },
    {
      key: "locale_en_45GB_46json_5ead3d14",
      load: () => import("#nuxt-i18n/5ead3d14" /* webpackChunkName: "locale_en_45GB_46json_5ead3d14" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_d803a8c4",
      load: () => import("#nuxt-i18n/d803a8c4" /* webpackChunkName: "locale_fi_46json_d803a8c4" */),
      cache: true
    },
    {
      key: "locale_fi_46json_ee4f24e9",
      load: () => import("#nuxt-i18n/ee4f24e9" /* webpackChunkName: "locale_fi_46json_ee4f24e9" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_0785dbda",
      load: () => import("#nuxt-i18n/0785dbda" /* webpackChunkName: "locale_sv_46json_0785dbda" */),
      cache: true
    },
    {
      key: "locale_sv_46json_29228316",
      load: () => import("#nuxt-i18n/29228316" /* webpackChunkName: "locale_sv_46json_29228316" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_d0ee585c",
      load: () => import("#nuxt-i18n/d0ee585c" /* webpackChunkName: "locale_de_46json_d0ee585c" */),
      cache: true
    },
    {
      key: "locale_de_46json_f497e6cf",
      load: () => import("#nuxt-i18n/f497e6cf" /* webpackChunkName: "locale_de_46json_f497e6cf" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_625cc1cf",
      load: () => import("#nuxt-i18n/625cc1cf" /* webpackChunkName: "locale_pl_46json_625cc1cf" */),
      cache: true
    },
    {
      key: "locale_pl_46json_8ca3893d",
      load: () => import("#nuxt-i18n/8ca3893d" /* webpackChunkName: "locale_pl_46json_8ca3893d" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en-GB",
      files: [
        {
          path: "/vercel/path0/packages/builder-components/i18n/locales/global/en-GB.json",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/eb-builder/i18n/locales/global/en-GB.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      files: [
        {
          path: "/vercel/path0/packages/builder-components/i18n/locales/global/fi.json",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/eb-builder/i18n/locales/global/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      files: [
        {
          path: "/vercel/path0/packages/builder-components/i18n/locales/global/sv.json",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/eb-builder/i18n/locales/global/sv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      files: [
        {
          path: "/vercel/path0/packages/builder-components/i18n/locales/global/de.json",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/eb-builder/i18n/locales/global/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      files: [
        {
          path: "/vercel/path0/packages/builder-components/i18n/locales/global/pl.json",
          cache: undefined
        },
        {
          path: "/vercel/path0/apps/eb-builder/i18n/locales/global/pl.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en-GB",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/global",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en-GB",
    files: [
      {
        path: "/vercel/path0/packages/builder-components/i18n/locales/global/en-GB.json",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/eb-builder/i18n/locales/global/en-GB.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    files: [
      {
        path: "/vercel/path0/packages/builder-components/i18n/locales/global/fi.json",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/eb-builder/i18n/locales/global/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    files: [
      {
        path: "/vercel/path0/packages/builder-components/i18n/locales/global/sv.json",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/eb-builder/i18n/locales/global/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    files: [
      {
        path: "/vercel/path0/packages/builder-components/i18n/locales/global/de.json",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/eb-builder/i18n/locales/global/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    files: [
      {
        path: "/vercel/path0/packages/builder-components/i18n/locales/global/pl.json",
        cache: undefined
      },
      {
        path: "/vercel/path0/apps/eb-builder/i18n/locales/global/pl.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/